import { z } from 'zod';

import { NOTIFICATION_KINDS } from '../enums';

export const RegisterSchema = z.object({
  email: z
    .string()
    .email()
    .transform((value) => value.toLowerCase()),
  password: z.string().min(12),
  name: z.string().trim().min(1).max(120).optional(),
});

export const LoginSchema = z.object({
  email: z
    .string()
    .email()
    .transform((value) => value.toLowerCase()),
  password: z.string().min(12),
});

const TimeSchema = z.string().regex(/^\d{2}:\d{2}$/);

export const NotificationPreferencesSchema = z.object({
  notifications: z.object({
    BREACH: z.literal(true).default(true),
    WEEKLY_REVIEW: z.boolean(),
    IMPORT_DONE: z.boolean(),
    JOURNAL_REQUIRED: z.boolean(),
    REVIEW_PENDING: z.boolean().default(true),
    RULE_CHANGE: z.boolean(),
  }),
  quietHours: z.object({
    start: TimeSchema,
    end: TimeSchema,
  }),
});

export const UpdatePreferencesSchema = NotificationPreferencesSchema;

export type RegisterInput = z.infer<typeof RegisterSchema>;
export type LoginInput = z.infer<typeof LoginSchema>;
export type NotificationPreferences = z.infer<typeof NotificationPreferencesSchema>;
export type UpdatePreferencesInput = z.infer<typeof UpdatePreferencesSchema>;

export const TOGGLEABLE_NOTIFICATION_KINDS = NOTIFICATION_KINDS.filter(
  (kind) => kind !== 'BREACH' && kind !== 'PRICE_ALERT',
);
